import styled from 'styled-components';
import { device } from 'modules/Utils';
import { isDevelop, isStage } from 'modules/Utils/Environment';
import { ZIndexes } from 'modules/Utils/ZIndexes';

export const Container = styled.div`
  z-index: ${ZIndexes.envIdentifier};
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
`;

export const IdentifierContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding-left: ${(props) => (props.$sidebarExpanded ? '26.4rem' : '9.2rem')};
  padding-right: 2.4rem;
  transition: padding 0.2s ease-in;

  @media ${device.tablet} {
    padding-right: 2.4rem;
  }

  @media ${device.mobile} {
    padding-left: 2.4rem;
    padding-right: 2.4rem;
  }

  color: ${(props) => props.theme.config.colors.light};
  background: ${(props) =>
    isDevelop
      ? props.theme.config.colors.black
      : isStage
      ? props.theme.config.colors.orange
      : props.theme.config.colors.text_base};
`;

export const IdentifierText = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: ${(props) => props.theme.config.spacing.spacing_1};
  }
`;

export const Env = styled.strong`
  display: block;
  margin-left: ${(props) => props.theme.config.spacing.spacing_1};
`;
